import { t } from 'i18next';
import PropTypes from 'prop-types';
import Button from '../shared/Button';

function HomeActionItem(props) {
  const { image, title, description, buttonTitle, to, disabled, variant } =
    props;

  return (
    <div
      className={`
        group relative flex flex-col bg-white rounded-xl overflow-hidden
        border border-slate-200
        shadow-sm hover:shadow-xl
        transition-all duration-300 ease-out
        hover:-translate-y-1
      `}
    >
      <div className="relative p-6 pb-4 flex justify-center items-center bg-gradient-to-b from-slate-50 to-white">
        <img
          alt={t('Image_Not_Available')}
          src={image}
          className="w-48 h-48 object-contain transition-transform duration-300 group-hover:scale-110"
        />
      </div>

      <div className="flex flex-col flex-1 p-5 pt-2">
        <h3 className="text-lg font-semibold text-primary mb-2">{title}</h3>
        <p className="text-slate-600 text-sm leading-relaxed flex-1 min-h-[48px]">
          {description}
        </p>

        <div className="mt-4 pt-4 border-t border-slate-100">
          <Button
            message={buttonTitle}
            onClick={to}
            disabled={disabled}
            type="primary"
            className="w-full justify-center"
          />
        </div>
      </div>
      <div></div>
    </div>
  );
}

HomeActionItem.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  to: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default HomeActionItem;
